<li>
  <div class="table_row_wrapper">
    <new-vehicle-detail [vehicleId]="vehicleId" [vehicle]="vehicle"></new-vehicle-detail>
  </div>
</li>
